/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateEdgeResponse } from '../models';
// @ts-ignore
import type { Edge } from '../models';
// @ts-ignore
import type { EdgeUpdate } from '../models';
// @ts-ignore
import type { ListEdgesResponse } from '../models';
// @ts-ignore
import type { LongRunningOperation } from '../models';
// @ts-ignore
import type { SetJoinTokenRequestJoinToken } from '../models';
// @ts-ignore
import type { SetPeeringInfoRequestPeeringInfo } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * EdgesV2BetaAPIApi - axios parameter creator
 * @export
 */
export const EdgesV2BetaAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Method to create an edge.
         * @summary Creates an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {Edge} edge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPICreateEdge: async (organizationId: string, clusterId: string, edgeLocationId: string, edge: Edge, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPICreateEdge', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPICreateEdge', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgesV2BetaAPICreateEdge', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'edge' is not null or undefined
            assertParamExists('edgesV2BetaAPICreateEdge', 'edge', edge)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/edges`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edge, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to delete an edge.
         * @summary Deletes an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be deleted.
         * @param {boolean} [force] Force deletion without waiting for cluster to be in a stable state.  This might leave hanging resources in the cluster. Use with caution.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIDeleteEdge: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIDeleteEdge', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPIDeleteEdge', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIDeleteEdge', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPIDeleteEdge', 'id', id)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/edges/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to generate the cloud init script for an edge.
         * @summary Get edge init script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIGetCloudInitScript: async (organizationId: string, clusterId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetCloudInitScript', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetCloudInitScript', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetCloudInitScript', 'id', id)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edges/{id}:getCloudInitScript`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to get an edge.
         * @summary Gets an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIGetEdge: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetEdge', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetEdge', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetEdge', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPIGetEdge', 'id', id)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/edges/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to list edges in a clusterwith various filters.
         * @summary List edges in omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} [edgeLocationId] Filter by edge location ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [clientRequestId] Filter by client_request_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIListEdges: async (organizationId: string, clusterId: string, edgeLocationId?: string, pageLimit?: string, pageCursor?: string, clientRequestId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIListEdges', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPIListEdges', 'clusterId', clusterId)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edges`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (edgeLocationId !== undefined) {
                localVarQueryParameter['edgeLocationId'] = edgeLocationId;
            }

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }

            if (clientRequestId !== undefined) {
                localVarQueryParameter['clientRequestId'] = clientRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets edge join token.
         * @summary Sets edge join token
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge.
         * @param {SetJoinTokenRequestJoinToken} setJoinTokenRequestJoinToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPISetJoinToken: async (organizationId: string, clusterId: string, id: string, setJoinTokenRequestJoinToken: SetJoinTokenRequestJoinToken, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPISetJoinToken', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPISetJoinToken', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPISetJoinToken', 'id', id)
            // verify required parameter 'setJoinTokenRequestJoinToken' is not null or undefined
            assertParamExists('edgesV2BetaAPISetJoinToken', 'setJoinTokenRequestJoinToken', setJoinTokenRequestJoinToken)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edges/{id}:setJoinToken`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setJoinTokenRequestJoinToken, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets peering info of a given edge.
         * @summary Sets peering info for an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster to be onboarded.
         * @param {string} id The ID of the edge.
         * @param {SetPeeringInfoRequestPeeringInfo} setPeeringInfoRequestPeeringInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPISetPeeringInfo: async (organizationId: string, clusterId: string, id: string, setPeeringInfoRequestPeeringInfo: SetPeeringInfoRequestPeeringInfo, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPISetPeeringInfo', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPISetPeeringInfo', 'clusterId', clusterId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPISetPeeringInfo', 'id', id)
            // verify required parameter 'setPeeringInfoRequestPeeringInfo' is not null or undefined
            assertParamExists('edgesV2BetaAPISetPeeringInfo', 'setPeeringInfoRequestPeeringInfo', setPeeringInfoRequestPeeringInfo)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edges/{id}:setPeeringInfo`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setPeeringInfoRequestPeeringInfo, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Method to update an edge.
         * @summary Updates an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be updated.
         * @param {EdgeUpdate} edgeUpdate 
         * @param {string} [updateMask] Field mask specifying which fields to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIUpdateEdge: async (organizationId: string, clusterId: string, edgeLocationId: string, id: string, edgeUpdate: EdgeUpdate, updateMask?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIUpdateEdge', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('edgesV2BetaAPIUpdateEdge', 'clusterId', clusterId)
            // verify required parameter 'edgeLocationId' is not null or undefined
            assertParamExists('edgesV2BetaAPIUpdateEdge', 'edgeLocationId', edgeLocationId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('edgesV2BetaAPIUpdateEdge', 'id', id)
            // verify required parameter 'edgeUpdate' is not null or undefined
            assertParamExists('edgesV2BetaAPIUpdateEdge', 'edgeUpdate', edgeUpdate)
            const localVarPath = `/omni-provisioner/v2beta/organizations/{organizationId}/clusters/{clusterId}/edge-locations/{edgeLocationId}/edges/{id}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)))
                .replace(`{${"edgeLocationId"}}`, encodeURIComponent(String(edgeLocationId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (updateMask !== undefined) {
                localVarQueryParameter['updateMask'] = updateMask;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(edgeUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EdgesV2BetaAPIApi - functional programming interface
 * @export
 */
export const EdgesV2BetaAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EdgesV2BetaAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Method to create an edge.
         * @summary Creates an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {Edge} edge 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPICreateEdge(organizationId: string, clusterId: string, edgeLocationId: string, edge: Edge, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEdgeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPICreateEdge(organizationId, clusterId, edgeLocationId, edge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPICreateEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to delete an edge.
         * @summary Deletes an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be deleted.
         * @param {boolean} [force] Force deletion without waiting for cluster to be in a stable state.  This might leave hanging resources in the cluster. Use with caution.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPIDeleteEdge(organizationId: string, clusterId: string, edgeLocationId: string, id: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LongRunningOperation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPIDeleteEdge(organizationId, clusterId, edgeLocationId, id, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPIDeleteEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to generate the cloud init script for an edge.
         * @summary Get edge init script
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPIGetCloudInitScript(organizationId: string, clusterId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPIGetCloudInitScript(organizationId, clusterId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPIGetCloudInitScript']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to get an edge.
         * @summary Gets an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be retrieved.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPIGetEdge(organizationId: string, clusterId: string, edgeLocationId: string, id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Edge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPIGetEdge(organizationId, clusterId, edgeLocationId, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPIGetEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to list edges in a clusterwith various filters.
         * @summary List edges in omni provider
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} [edgeLocationId] Filter by edge location ID.
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {string} [clientRequestId] Filter by client_request_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPIListEdges(organizationId: string, clusterId: string, edgeLocationId?: string, pageLimit?: string, pageCursor?: string, clientRequestId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListEdgesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPIListEdges(organizationId, clusterId, edgeLocationId, pageLimit, pageCursor, clientRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPIListEdges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets edge join token.
         * @summary Sets edge join token
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster.
         * @param {string} id The ID of the edge.
         * @param {SetJoinTokenRequestJoinToken} setJoinTokenRequestJoinToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPISetJoinToken(organizationId: string, clusterId: string, id: string, setJoinTokenRequestJoinToken: SetJoinTokenRequestJoinToken, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPISetJoinToken(organizationId, clusterId, id, setJoinTokenRequestJoinToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPISetJoinToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets peering info of a given edge.
         * @summary Sets peering info for an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The ID of the cluster to be onboarded.
         * @param {string} id The ID of the edge.
         * @param {SetPeeringInfoRequestPeeringInfo} setPeeringInfoRequestPeeringInfo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPISetPeeringInfo(organizationId: string, clusterId: string, id: string, setPeeringInfoRequestPeeringInfo: SetPeeringInfoRequestPeeringInfo, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPISetPeeringInfo(organizationId, clusterId, id, setPeeringInfoRequestPeeringInfo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPISetPeeringInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Method to update an edge.
         * @summary Updates an edge
         * @param {string} organizationId The ID of the Organization.
         * @param {string} clusterId The cluster ID.
         * @param {string} edgeLocationId The edge location ID.
         * @param {string} id The ID of the edge to be updated.
         * @param {EdgeUpdate} edgeUpdate 
         * @param {string} [updateMask] Field mask specifying which fields to update.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async edgesV2BetaAPIUpdateEdge(organizationId: string, clusterId: string, edgeLocationId: string, id: string, edgeUpdate: EdgeUpdate, updateMask?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Edge>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.edgesV2BetaAPIUpdateEdge(organizationId, clusterId, edgeLocationId, id, edgeUpdate, updateMask, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EdgesV2BetaAPIApi.edgesV2BetaAPIUpdateEdge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EdgesV2BetaAPIApi - factory interface
 * @export
 */
export const EdgesV2BetaAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EdgesV2BetaAPIApiFp(configuration)
    return {
        /**
         * Method to create an edge.
         * @summary Creates an edge
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPICreateEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateEdgeResponse> {
            return localVarFp.edgesV2BetaAPICreateEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.edge, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to delete an edge.
         * @summary Deletes an edge
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIDeleteEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LongRunningOperation> {
            return localVarFp.edgesV2BetaAPIDeleteEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.force, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to generate the cloud init script for an edge.
         * @summary Get edge init script
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIGetCloudInitScript(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.edgesV2BetaAPIGetCloudInitScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to get an edge.
         * @summary Gets an edge
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIGetEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Edge> {
            return localVarFp.edgesV2BetaAPIGetEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to list edges in a clusterwith various filters.
         * @summary List edges in omni provider
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIListEdges(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListEdgesResponse> {
            return localVarFp.edgesV2BetaAPIListEdges(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clientRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets edge join token.
         * @summary Sets edge join token
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPISetJoinToken(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.edgesV2BetaAPISetJoinToken(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.setJoinTokenRequestJoinToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets peering info of a given edge.
         * @summary Sets peering info for an edge
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPISetPeeringInfo(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.edgesV2BetaAPISetPeeringInfo(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.setPeeringInfoRequestPeeringInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * Method to update an edge.
         * @summary Updates an edge
         * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edgesV2BetaAPIUpdateEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Edge> {
            return localVarFp.edgesV2BetaAPIUpdateEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.edgeUpdate, requestParameters.updateMask, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for edgesV2BetaAPICreateEdge operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdge
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdge
     */
    readonly clusterId: string

    /**
     * The edge location ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdge
     */
    readonly edgeLocationId: string

    /**
     * 
     * @type {Edge}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdge
     */
    readonly edge: Edge
}

/**
 * Request parameters for edgesV2BetaAPIDeleteEdge operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdge
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdge
     */
    readonly clusterId: string

    /**
     * The edge location ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdge
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge to be deleted.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdge
     */
    readonly id: string

    /**
     * Force deletion without waiting for cluster to be in a stable state.  This might leave hanging resources in the cluster. Use with caution.
     * @type {boolean}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdge
     */
    readonly force?: boolean
}

/**
 * Request parameters for edgesV2BetaAPIGetCloudInitScript operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScript
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScript
     */
    readonly clusterId: string

    /**
     * The ID of the edge.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScript
     */
    readonly id: string
}

/**
 * Request parameters for edgesV2BetaAPIGetEdge operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdge
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdge
     */
    readonly clusterId: string

    /**
     * The edge location ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdge
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge to be retrieved.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdge
     */
    readonly id: string
}

/**
 * Request parameters for edgesV2BetaAPIListEdges operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly clusterId: string

    /**
     * Filter by edge location ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly edgeLocationId?: string

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly pageCursor?: string

    /**
     * Filter by client_request_id.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIListEdges
     */
    readonly clientRequestId?: string
}

/**
 * Request parameters for edgesV2BetaAPISetJoinToken operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinToken
     */
    readonly organizationId: string

    /**
     * The ID of the cluster.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinToken
     */
    readonly clusterId: string

    /**
     * The ID of the edge.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinToken
     */
    readonly id: string

    /**
     * 
     * @type {SetJoinTokenRequestJoinToken}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinToken
     */
    readonly setJoinTokenRequestJoinToken: SetJoinTokenRequestJoinToken
}

/**
 * Request parameters for edgesV2BetaAPISetPeeringInfo operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfo
     */
    readonly organizationId: string

    /**
     * The ID of the cluster to be onboarded.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfo
     */
    readonly clusterId: string

    /**
     * The ID of the edge.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfo
     */
    readonly id: string

    /**
     * 
     * @type {SetPeeringInfoRequestPeeringInfo}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfo
     */
    readonly setPeeringInfoRequestPeeringInfo: SetPeeringInfoRequestPeeringInfo
}

/**
 * Request parameters for edgesV2BetaAPIUpdateEdge operation in EdgesV2BetaAPIApi.
 * @export
 * @interface EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest
 */
export interface EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest {
    /**
     * The ID of the Organization.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly organizationId: string

    /**
     * The cluster ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly clusterId: string

    /**
     * The edge location ID.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly edgeLocationId: string

    /**
     * The ID of the edge to be updated.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly id: string

    /**
     * 
     * @type {EdgeUpdate}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly edgeUpdate: EdgeUpdate

    /**
     * Field mask specifying which fields to update.
     * @type {string}
     * @memberof EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdge
     */
    readonly updateMask?: string
}

/**
 * EdgesV2BetaAPIApi - object-oriented interface
 * @export
 * @class EdgesV2BetaAPIApi
 * @extends {BaseAPI}
 */
export class EdgesV2BetaAPIApi extends BaseAPI {
    /**
     * Method to create an edge.
     * @summary Creates an edge
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPICreateEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPICreateEdgeRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPICreateEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.edge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to delete an edge.
     * @summary Deletes an edge
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPIDeleteEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIDeleteEdgeRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPIDeleteEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to generate the cloud init script for an edge.
     * @summary Get edge init script
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPIGetCloudInitScript(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIGetCloudInitScriptRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPIGetCloudInitScript(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to get an edge.
     * @summary Gets an edge
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPIGetEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIGetEdgeRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPIGetEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to list edges in a clusterwith various filters.
     * @summary List edges in omni provider
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPIListEdges(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIListEdgesRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPIListEdges(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.pageLimit, requestParameters.pageCursor, requestParameters.clientRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets edge join token.
     * @summary Sets edge join token
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPISetJoinToken(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPISetJoinTokenRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPISetJoinToken(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.setJoinTokenRequestJoinToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets peering info of a given edge.
     * @summary Sets peering info for an edge
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPISetPeeringInfo(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPISetPeeringInfoRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPISetPeeringInfo(requestParameters.organizationId, requestParameters.clusterId, requestParameters.id, requestParameters.setPeeringInfoRequestPeeringInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Method to update an edge.
     * @summary Updates an edge
     * @param {EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EdgesV2BetaAPIApi
     */
    public edgesV2BetaAPIUpdateEdge(requestParameters: EdgesV2BetaAPIApiEdgesV2BetaAPIUpdateEdgeRequest, options?: RawAxiosRequestConfig) {
        return EdgesV2BetaAPIApiFp(this.configuration).edgesV2BetaAPIUpdateEdge(requestParameters.organizationId, requestParameters.clusterId, requestParameters.edgeLocationId, requestParameters.id, requestParameters.edgeUpdate, requestParameters.updateMask, options).then((request) => request(this.axios, this.basePath));
    }
}

